module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.240f8d9c.svg";